export var DATA_HOOKS = {
    WSR_CALENDAR: 'wsr-calendar',
};
//# sourceMappingURL=constants.js.map